<template>
    <div class="full-screen-container admin-home">
        <admin-head />
        <div class="admin-content-container">
            <div class="left-menu-container">
                <el-menu :collapse-transition="false"
                         :collapse="isActive" router unique-opened
                         active-text-color="#377f7f"
                         :default-active="activePath"
                         background-color="#ecfefe" text-color="#333"
                         @open="handleOpen" @close="handleClose">
                    <div v-for="item in menusList" :key="item">
                        <el-sub-menu v-if="menuHasChildren(item)" :index="item.path" >
                            <template #title>
                                <el-icon><component :is="item.icon" /></el-icon>
                                <span class="fw">{{item.title}}</span>
                            </template>
                            <el-menu-item v-for="childItem in item.children" :key="childItem" :index="childItem.path">
                                <span class="fw">{{childItem.title}}</span>
                            </el-menu-item>
                        </el-sub-menu>
                        <el-menu-item v-if="!menuHasChildren(item)" :index="item.path">
                            <el-icon><component :is="item.icon" /></el-icon>
                            <span class="fw">{{item.title}}</span>
                        </el-menu-item>
                    </div>
                </el-menu>
            </div>

            <div class="right-router-container">
                <router-view v-slot="{ Component, route }">
                    <keep-alive :include="cachedViews">
                        <component  :key="route.name" :is="Component" v-if="$route.meta.keepAlive" />
                    </keep-alive>
                    <component  :key="route.name" :is="Component" v-if="!$route.meta.keepAlive" />
                </router-view>
            </div>
        </div>
    </div>
</template>
<script>
import adminHead from "@/components/common/adminHead.vue";
export default {
    components: {adminHead},
    name: "AdminHome",
    data() {
        return {
            isActive: false,
            activePath: "overview",
            role: this.$storage.get("role"),
            menusList:[],
            // 系统管理菜单列表
            sysMeunsList:[
                { title: '概览', path: 'overview', icon: 'HomeFilled'},
                {
                    title: '组织管理', path: 'supplierLevelOne', icon: 'Menu',
                    children:[
                        { title: '一级代理', path: 'supplierLevelOne', icon: 'Menu' },
                        { title: '二级代理', path: 'supplierLevelTwo', icon: 'Menu' },
                        { title: '组织机构', path: 'org', icon: 'Menu' },
                        { title: '用户管理', path: 'user', icon: 'Menu' },
                    ]
                },
                { title: '卡管理', path: 'card', icon: 'Management'},
                { title: '书目管理', path: 'book', icon: 'List'},
                {
                    title: '五馆活动', path: 'event', icon: 'WalletFilled',
                    children:[
                        { title: '读书会', path: 'event', icon: 'Menu' },
                        { title: '主题活动', path: 'museumActivity', icon: 'Menu' },
                        { title: '营在规划', path: 'excursion', icon: 'Menu' },
                    ]
                },
                {
                    title: '活动竞赛', path: 'race', icon: 'Histogram',
                    children:[
                        { title: '教研赛事', path: 'race', icon: 'Menu' },
                        { title: '专题活动', path: 'activity', icon: 'Menu' },
                        /* { title: '成果管理', path: 'overview', icon: 'Menu' }, */
                    ]
                },
                {
                    title: '教研管理', path: 'selfLesson', icon: 'Platform',
                    children:[
                        { title: '个人备课', path: 'selfLesson', icon: 'Menu' },
                        { title: '协同备课', path: 'teamLesson', icon: 'Menu' },
                        { title: '听评课', path: 'evaLesson', icon: 'Menu' },
                    ]
                },
                {
                    title: '系统管理', path: 'systemManager', icon: 'Grid',
                    children:[
                        { title: '五馆配置', path: 'museumConfig', icon: 'Menu' },
                    ]
                },
            ],
            // 一级代理商菜单列表
            supplier1MeunsList:[
                { title: '概览', path: 'overview', icon: 'HomeFilled'},
                { title: '卡管理', path: 'supplier1Card', icon: 'Management'},
                {
                    title: '组织管理', path: 'supplierLevelOne', icon: 'Menu',
                    children:[
                        { title: '二级代理', path: 'supplier1Level', icon: 'Menu' },
                        { title: '组织机构', path: 'supplier1Org', icon: 'Menu' },
                    ]
                },
            ],
            // 二级代理商管理列表
            supplier2MeunsList:[
                { title: '概览', path: 'overview', icon: 'HomeFilled'},
                { title: '卡管理', path: 'supplier2Card', icon: 'Management'},
                {
                    title: '组织管理', path: 'supplierLevelOne', icon: 'Menu',
                    children:[
                        { title: '组织机构', path: 'supplier2Org', icon: 'Menu' },
                    ]
                },
            ],
            // 组织结构管理列表
            orgMeunsList:[
                { title: '概览', path: 'overview', icon: 'HomeFilled'},
                {
                    title: '组织管理', path: 'supplierLevelOne', icon: 'Menu',
                    children:[
                        { title: '用户管理', path: 'user', icon: 'Menu' },
                    ]
                },
                {
                    title: '教研管理', path: 'selfLesson', icon: 'Platform',
                    children:[
                        { title: '个人备课', path: 'selfLesson', icon: 'Menu' },
                        { title: '协同备课', path: 'teamLesson', icon: 'Menu' },
                        { title: '听评课', path: 'evaLesson', icon: 'Menu' },
                    ]
                },
            ],
        }
    },
    computed: {
        cachedViews() {
            return this.$store.state.tagsView.cachedViews
        },
    },
    watch: {},
    created() {
        if (this.role==='1'||this.role==='2') {
            this.menusList = this.sysMeunsList;
        }
        if (this.role==='3') {
            this.menusList = this.supplier1MeunsList;
        }
        if (this.role==='4') {
            this.menusList = this.supplier2MeunsList;
        }
        if (this.role==='5') {
            this.menusList = this.orgMeunsList;
        }
    },
    mounted() {},
    methods: {
        handleOpen(){ },
        handleClose(){ },
        menuHasChildren(item){
            return item.children && item.children.length > 0;
        },
    }
}
</script>
<!--内联样式-->
<style>
.admin-home{
    background-image: url("../../assets/image/admin-bg.png");
}
.admin-content-container{
    width: 100%;
    height: calc(100vh - 60px);
    padding: 10px 10px 10px 10px;
    box-sizing: border-box;
    display: flex;
}
.left-menu-container{
    width: 200px;
    height: calc(100vh - 80px);
    border: 1px solid #e5e8ec;
    border-radius: 5px;
    overflow-y: auto;
}
.left-menu-container::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera*/
}
.right-router-container{
    width: calc(100vw - 220px);
    height: calc(100vh - 80px);
    margin-left: 20px;
    border: 1px solid #e5e8ec;
    border-radius: 5px;
    padding: 10px 10px 10px 10px;
    box-sizing: border-box;
}



</style>
